export interface Sector {
  id: string
  nameKey: string
  descriptionKey: string
  heroImage: string
  slug: {
    it: string
    en: string
  }
  /** Product IDs relevant to this sector */
  recommendedProductIds: string[]
}

export const sectors: Sector[] = [
  {
    id: 'polizia-locale',
    nameKey: 'sectors.police.name',
    descriptionKey: 'sectors.police.description',
    heroImage: '/media/sectors/telecamere-videosorveglianza-polizia-locale.jpg',
    slug: { it: 'polizia-locale', en: 'local-police' },
    recommendedProductIds: ['targa-960', 'targa-860', 'targa-760', 'targa-706', 'cps-6-5', 'targa-scanner'],
  },
  {
    id: 'forze-ordine',
    nameKey: 'sectors.lawEnforcement.name',
    descriptionKey: 'sectors.lawEnforcement.description',
    heroImage: '/media/sectors/telecamere-videosorveglianza-forze-ordine.jpg',
    slug: { it: 'forze-ordine', en: 'law-enforcement' },
    recommendedProductIds: ['targa-960', 'targa-860', 'cps-manager', 'targa-scanner', 'targa-706', 'targa-306'],
  },
  {
    id: 'porti-aeroporti',
    nameKey: 'sectors.portsAirports.name',
    descriptionKey: 'sectors.portsAirports.description',
    heroImage: '/media/sectors/telecamere-videosorveglianza-porti-aeroporti.jpg',
    slug: { it: 'porti-aeroporti', en: 'ports-airports' },
    recommendedProductIds: ['targa-706-ilb', 'targa-960', 'targa-860', 'izero-2', 'targa-inox', 'cps-6-5'],
  },
  {
    id: 'parking',
    nameKey: 'sectors.parking.name',
    descriptionKey: 'sectors.parking.description',
    heroImage: '/media/sectors/telecamere-videosorveglianza-parking.jpg',
    slug: { it: 'parking', en: 'parking' },
    recommendedProductIds: ['izero-2', 'izero-box', 'qentry-smart-parking', 'targa-512', 'targa-504', 'targa-560'],
  },
]

export function getSectorBySlug(slug: string): Sector | undefined {
  return sectors.find((s) => s.slug.it === slug || s.slug.en === slug)
}
